export default __webpack_public_path__ + "static/media/outpatient-icon.e4650e89.svg";